import { CssBaseline } from '@mui/material'
import { ThemeProvider } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import PouchDb from 'pouchdb-browser'
import { useRef, useState } from 'react'

import { Main } from './components/Main'
import { DbContext } from './contexts/DbContext'
import { RefreshSignalContext } from './contexts/refreshSignal'
import getTheme from './theme'

const db = new PouchDb('sasavi-db')

const App = () => {
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)')
  const theme = getTheme(prefersDarkMode ? 'dark' : 'light')
  const dbRef = useRef(db)

  // const [itemToUpdate, setItemToUpdate] = useState(null)
  const [refreshTrigger, setRefreshTrigger] = useState(0)

  const triggerRefresh = () => {
    setRefreshTrigger(prev => {
      return prev + 1
    })
  }


  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <DbContext.Provider value={dbRef}>
          <RefreshSignalContext.Provider value={{ refreshTrigger, triggerRefresh }}>
            <Main />
          </RefreshSignalContext.Provider>
      </DbContext.Provider>
    </ThemeProvider>
  )
}

export default App



// const fetchFeed = useCallback(async (isFilterByLiked) => {
  //   try {
  //     console.log("fetch feed called 1", isFilterByLiked);
  //     const options = isFilterByLiked ? {liked: true} : {}
  //     console.log("fetch feed called 2", options);
  //     const something = await db.allDocs({ include_docs: true });
  //     console.log("feed data", something.rows);

  //     let data = await Promise.all(
  //       something.rows.map(async (r) => {
  //         const foo = await db.get(r.id);
  //         return foo;
  //       })
  //     );

  //     if (isFilterByLiked) {
  //       data = data.filter((item) => item.liked === true)
  //     }

  //     const sortedData = data.sort((a, b) => {
  //       return new Date(b.createdAt) - new Date(a.createdAt);
  //     });

  //     console.log("updating the feed")
  //     updateFeedData(sortedData)
      
  //   } catch (error) {
  //     console.error("Error fetching db feed:", error);
  //   }
  // }, []);